'use strict';
//import $ from 'jquery';
import {log}
    from './BpmnDebug';

/*Blockly = require('../node_modules/ngx-blockly/scripts/blockly/blockly_compressed')
Blockly.Msg = require ('../node_modules/blockly/msg/json/en.json');
Blockly.JavaScript = require('../node_modules/blockly/javascript_compressed');
Blockly.Blocks = require('../node_modules/blockly/blocks_compressed');*/


// Named this BlocklyBpmn because 'Blockly' will be a conflict with the Blockly version used in Business logic
// Workflow uses Blockly version 3 from ngx-blockly while Business logic uses Blockly v9
let BlocklyBpmn = require('../../../../node_modules/ngx-blockly/scripts/blockly/blockly_compressed');
BlocklyBpmn.Msg = require ('../../../../node_modules/ngx-blockly/scripts/blockly/msg/json/en.json');
BlocklyBpmn.JavaScript = require('../../../../node_modules/ngx-blockly/scripts/blockly/javascript_compressed');
BlocklyBpmn.Blocks = require('../../../../node_modules/ngx-blockly/scripts/blockly/blocks_compressed');

BlocklyBpmn.Msg["CONTROLS_IF_MSG_THEN"] = "then";
BlocklyBpmn.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = "else if";
BlocklyBpmn.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = "else";
BlocklyBpmn.Msg["CONTROLS_IF_IF_TITLE_IF"] = "if";
BlocklyBpmn.Msg["TEXT_APPEND_VARIABLE"] = "i";


var BpmnBlocklyHelper = {};
//module.exports = BpmnBlocklyHelper;
export default BpmnBlocklyHelper;

/**
 *
 * @param {type} blocklyDiv - html id
 * @param {type} variableNames
 *
 * var names
 * { xyz : [ 'xyz','xyz.a','xyz.b]{,
 * {_errorCode: [_errorCode]}

 * @returns {BlocklyBpmn.WorkspaceSvg|BlocklyBpmn.createMainWorkspace_.mainWorkspace|!BlocklyBpmn.WorkspaceSvg|BpmnBlocklyHelper.createWorkspace.workspace|nm$_BpmnBlocklyHelper.BpmnBlocklyHelper.createWorkspace.workspace}
 */
BpmnBlocklyHelper.createWorkspace = function (blocklyDiv, variableNames) {
    // let variableNames = ["abc", "def"];
    log("in BpmnBlocklyHelper.createWorkspace", variableNames);
    let varsToAdd = [];
    for (let i in variableNames) {
        let variable = variableNames[i];
        let name = i;
        varsToAdd.push({
            "kind": "block",
            "type": name
        });
        let varOptions = [];
        for (let j = 0; j < variable.length; j++) {
            let opt = variable[j];
            varOptions.push([opt, opt]);
        }

        BlocklyBpmn.Blocks[name] = {
            nameDiv: name,
            init: function () {
                log("in constant init", name, variable, varOptions);
                if (varOptions && varOptions.length) {
                    log("missing var options", varOptions, variable);
                    this.appendDummyInput()
                        .appendField(new BlocklyBpmn.FieldDropdown(varOptions), "NAME");
                } else {
                    this.appendDummyInput();
                }
                this.setInputsInline(false);
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip("oii");
                this.setHelpUrl(this.nameDiv);
            }
        };

        BlocklyBpmn.JavaScript[name] = function (block) {
            var dropdown_name = block.getFieldValue('NAME');
            // TODO: Assemble JavaScript into code variable.
            var code = dropdown_name;
            // TODO: Change ORDER_NONE to the correct strength.
            return [code, BlocklyBpmn.JavaScript.ORDER_NONE];
        };

    }
    const json = {
        "kind": "categoryToolbox",
        "contents": [
            {
                "kind": "category",
                "name": "Logic",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_if'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_compare'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_operation'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_negate'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_boolean'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_null'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='logic_ternary'></block>"
                    }
                ]
            },
            {
                "kind": "category",
                "name": "Loops",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_repeat_ext'>  <value name='TIMES'> <shadow type='math_number'> <field name='NUM'>10</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_whileUntil'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_for'> <value name='FROM'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> <value name='TO'> <shadow type='math_number'> <field name='NUM'>10</field> </shadow> </value> <value name='BY'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_forEach'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='controls_flow_statements'></block>"
                    }
                ]
            },
            {
                "kind": "category",
                "name": "Math",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_number'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_arithmetic'> <value name='A'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> <value name='B'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_single'> <value name='NUM'> <shadow type='math_number'> <field name='NUM'>9</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_trig'> <value name='NUM'> <shadow type='math_number'> <field name='NUM'>45</field> </shadow> </value> </block>"
                    },

                    {
                        "kind": "block",
                        "blockxml": "<block type='math_constant'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_number_property'> <value name='NUMBER_TO_CHECK'> <shadow type='math_number'> <field name='NUM'>0</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_round'> <value name='NUM'> <shadow type='math_number'> <field name='NUM'>3.1</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_on_list'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_modulo'> <value name='DIVIDEND'> <shadow type='math_number'> <field name='NUM'>64</field> </shadow> </value> <value name='DIVISOR'> <shadow type='math_number'> <field name='NUM'>10</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_constrain'> <value name='VALUE'> <shadow type='math_number'> <field name='NUM'>50</field> </shadow> </value> <value name='LOW'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> <value name='HIGH'> <shadow type='math_number'> <field name='NUM'>100</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_random_int'> <value name='FROM'> <shadow type='math_number'> <field name='NUM'>1</field> </shadow> </value> <value name='TO'> <shadow type='math_number'> <field name='NUM'>100</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='math_random_float'></block>"
                    }
                ]
            },
            {
                "kind": "category",
                "name": "JSON",
                "contents": [

                    {
                        "kind": "block",
                        "blockxml": "<block type='dictionary'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='array'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='number'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='string'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='true'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='false'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='start'></block>"
                    }
                    ,
                    {
                        "kind": "block",
                        "blockxml": "<block type='json_stringify'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='json_raw'></block>"
                    }


                ]
            }
            ,
            {
                "kind": "category",
                "name": "Text",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='text'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_join'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_append'> <value name='TEXT'> <shadow type='text'></shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_length'> <value name='VALUE'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_isEmpty'> <value name='VALUE'> <shadow type='text'> <field name='TEXT'></field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_indexOf'> <value name='VALUE'> <block type='variables_get'> <field name='VAR'>{textVariable}</field> </block> </value> <value name='FIND'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_charAt'> <value name='VALUE'> <block type='variables_get'> <field name='VAR'>{textVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_getSubstring'> <value name='STRING'> <block type='variables_get'> <field name='VAR'>{textVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_changeCase'> <value name='TEXT'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_trim'> <value name='TEXT'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_print'> <value name='TEXT'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='text_prompt_ext'> <value name='TEXT'> <shadow type='text'> <field name='TEXT'>abc</field> </shadow> </value> </block>"
                    }
                ]
            },
            {
                "kind": "category",
                "name": "Lists",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_create_with'> <mutation items='0'></mutation> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_create_with'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_repeat'> <value name='NUM'> <shadow type='math_number'> <field name='NUM'>5</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_length'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_isEmpty'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_indexOf'> <value name='VALUE'> <block type='variables_get'> <field name='VAR'>{listVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_getIndex'> <value name='VALUE'> <block type='variables_get'> <field name='VAR'>{listVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_setIndex'> <value name='LIST'> <block type='variables_get'> <field name='VAR'>{listVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_getSublist'> <value name='LIST'> <block type='variables_get'> <field name='VAR'>{listVariable}</field> </block> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_split'> <value name='DELIM'> <shadow type='text'> <field name='TEXT'>,</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='lists_sort'></block>"
                    }
                ]
            },
            {
                "kind": "category",
                "name": "Colour",
                "contents": [
                    {
                        "kind": "block",
                        "blockxml": "<block type='colour_picker'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='colour_random'></block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='colour_rgb'> <value name='RED'> <shadow type='math_number'> <field name='NUM'>100</field> </shadow> </value> <value name='GREEN'> <shadow type='math_number'> <field name='NUM'>50</field> </shadow> </value> <value name='BLUE'> <shadow type='math_number'> <field name='NUM'>0</field> </shadow> </value> </block>"
                    },
                    {
                        "kind": "block",
                        "blockxml": "<block type='colour_blend'> <value name='COLOUR1'> <shadow type='colour_picker'> <field name='COLOUR'>#ff0000</field> </shadow> </value> <value name='COLOUR2'> <shadow type='colour_picker'> <field name='COLOUR'>#3333ff</field> </shadow> </value> <value name='RATIO'> <shadow type='math_number'> <field name='NUM'>0.5</field> </shadow> </value> </block>"
                    }
                ]
            },
            {
                "kind": "sep",
                "cssConfig": {
                    "container": "yourClassName"
                }
            },
            {
                "kind": "category",
                "name": "Variables",
                "contents": varsToAdd
            }
        ]
    };


    // if we have an existing workspace, delete it, then create it
    let workspace = BlocklyBpmn.getMainWorkspace();
    if (workspace) {
        workspace.dispose();
    }

    let toolboxXml = BpmnBlocklyHelper.convertJsonToToolboxXml(json);
    //log("injecting workspace with toolbox json ",toolboxXml);
    /*log("blockly",Blockly);
    log("blockly msg ",Blockly.Msg)
    log("msg ",msg);
    log("blockly javascript",Blockly.JavaScript);
    log("blockly blocks",Blockly.Block);*/
    workspace = BlocklyBpmn.inject(blocklyDiv,
        {
            toolbox: toolboxXml,//json, //document.getElementById(toolbox),
            media: 'https://blockly-demo.appspot.com/static/media/'
        });

    const lang = 'JavaScript';
    const button = document.getElementById('blocklyButton');
    if (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            //alert("Check the console for the generated output.");
//        const code = Blockly[lang].workspaceToCode(workspace);
//        log(code);
            const xml = BpmnBlocklyHelper.getXML(workspace);

            const json = BlocklyBpmn.JavaScript.fromWorkspace(workspace, false);
            var code = BlocklyBpmn.JavaScript.workspaceToCode(workspace);
            log("code is ", code);
            log("json is ", json);
            log("xml is ", xml);
            let inputdata = document.getElementById('blocklydata');
            inputdata.value = json + "\n" + xml;
            //alert(xml);
            return null;
        });
    }

    const buttonload = document.getElementById('blocklyload');
    if (buttonload) {
        buttonload.addEventListener('click', function (event) {
            event.preventDefault();
            //alert("Check the console for the generated output.");
            let inputdata = document.getElementById('blocklydata');
            let json_text = inputdata.value;
            log(json_text);
            //Blockly.JavaScript.toWorkspace (json_text, workspace);
            BpmnBlocklyHelper.loadXML(json_text, workspace);//actually xml

            return null;
        });
    }

    //workspace.createVariable('xxx');
    return workspace;
}

BpmnBlocklyHelper.convertJsonToToolboxXml = function (json) {
    log("convertJsonToToolboxXml", json);


    var toolbox = '<xml>';
    var contents = json.contents;
    for (let i = 0; i < contents.length; i++) {
        let content = contents[i];
        let kind = content.kind;
        let name = content.name;
        //log("content is ",content,"name is",name);
        let items = content.contents;
        //log("items",items);
        if (items) {

            toolbox += ' <category name="' + name + '">\n';
            for (let j = 0; j < items.length; j++) {
                let item = items[j];
                let blockXml = item.blockxml;
                let type = item.type;
                if (blockXml) {
                    toolbox += blockXml + '\n';
                } else if (type) {
                    toolbox += '  <block type="' + type + '"></block>';
                }
            }

            toolbox += ' </category>\n';

        }
    }


    toolbox += '</xml>';
    //log('toolbox is ', toolbox);
    return toolbox;
}
BpmnBlocklyHelper.getOptionList = function () {
    log("get option list called");
    return [["option", "OPTIONNAME"], ["option", "OPTIONNAME"], ["option", "OPTIONNAME"]];
}


BpmnBlocklyHelper.createNewBlockly = function (blocklyDiv, srcParams, destParams, businessObject, json) {
    let workspace = BpmnBlocklyHelper.createWorkspace(blocklyDiv, srcParams);
    BpmnBlocklyHelper.loadJson(JSON.stringify(json), workspace);//todo do we have to stringify??


}
BpmnBlocklyHelper.createNewBlocklyCondition = function (blocklyDiv, srcParams, destParams, businessObject, json) {
    let workspace = BpmnBlocklyHelper.createWorkspace(blocklyDiv, srcParams);
    //BpmnBlocklyHelper.loadJson(JSON.stringify(json), workspace);//todo do we have to stringify??


}

BpmnBlocklyHelper.getCode = function (workspace) {
    if (!workspace) {
        workspace = BlocklyBpmn.getMainWorkspace();
    }
    var code = BlocklyBpmn.JavaScript.workspaceToCode(workspace);
    return code;
}

BlocklyBpmn.selectionArrow = function () {
    return BlocklyBpmn.RTL ? "←" : "→";
};
BlocklyBpmn.keyValueArrow = function () {
    return BlocklyBpmn.RTL ? "⇐" : "⇒";
};

BlocklyBpmn.Blocks['json_stringify'] = {
    init: function () {
        this.appendValueInput("jsonObj")
            .setCheck(null)
            .appendField("Stringify");
        this.setOutput(true, "String");
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
    }
};
BlocklyBpmn.JavaScript['json_stringify'] = function (block) {
    log("json_stringify", block);
    var value_jsonobj = BlocklyBpmn.JavaScript.generalBlockToObj(block.getInputTargetBlock('jsonObj'), true);
    log("json_stringify value_jsonobj", value_jsonobj);
    let stringifiedJson = /*JSON.stringify*/(value_jsonobj);
    //var value_jsonobj = Blockly.JavaScript.valueToCode(block, 'jsonObj', Blockly.JavaScript.ORDER_ATOMIC);
    // TODO: Assemble JavaScript into code variable.
    var code = 'JSON.stringify(' + stringifiedJson + ')';
    // TODO: Change ORDER_NONE to the correct strength.
    return [code, BlocklyBpmn.JavaScript.ORDER_NONE];
};
BlocklyBpmn.Blocks['json_raw'] = {
    init: function () {
        this.appendValueInput("jsonObj")
            .setCheck(null)
            .appendField("Raw");
        this.setOutput(true, "String");
        this.setColour(230);
        this.setTooltip("");
        this.setHelpUrl("");
    }
};
BlocklyBpmn.JavaScript['json_raw'] = function (block) {
    log("json_raw", block);
    //block.getFieldValue('string_value');
    log("json_raw field value", block.getFieldValue('jsonObj'));
    var value_jsonobj = BlocklyBpmn.JavaScript.generalBlockToObj(block.getInputTargetBlock('jsonObj'), true);
    log("json_raw  value_jsonobj", value_jsonobj);
    var code = value_jsonobj;
    if (value_jsonobj instanceof BpmnBlockly_code) {
        code = value_jsonobj.code;
        if (value_jsonobj.type == "text"
            || value_jsonobj.type == "string") {
            // if text, it will have single quotes first and last need to remove them
            var code = code.substring(1, code.length - 1);

        }
    }

    //var value_jsonobj = Blockly.JavaScript.valueToCode(block, 'jsonObj', Blockly.JavaScript.ORDER_ATOMIC);
    // TODO: Assemble JavaScript into code variable.

    // TODO: Change ORDER_NONE to the correct strength.
    return [code, BlocklyBpmn.JavaScript.ORDER_NONE];
};

BlocklyBpmn.Blocks['start'] = {
    init: function () {
        this.setColour(250);
        this.appendDummyInput()
            .setAlign(BlocklyBpmn.ALIGN_CENTRE)
            .appendField("JSON structure");

        this.appendValueInput('json')
            .appendSelector(['dictionary', 'array', 'string', 'number', 'true', 'false'], BlocklyBpmn.selectionArrow(), 'null');

        this.setDeletable(false);
    }
};


BlocklyBpmn.Blocks['true'] = {
    init: function () {
        this.setColour(20);
        this.setOutput(true, ["element"]);

        this.appendDummyInput()
            .setAlign(BlocklyBpmn.ALIGN_CENTRE)
            .appendField('true');
    }
};


BlocklyBpmn.Blocks['false'] = {
    init: function () {
        this.setColour(20);
        this.setOutput(true, ["element"]);

        this.appendDummyInput()
            .setAlign(BlocklyBpmn.ALIGN_CENTRE)
            .appendField('false');
    }
};


BlocklyBpmn.Blocks['string'] = {
    init: function () {
        this.setColour(190);
        this.setOutput(true, ["element"]);

        this.appendDummyInput()
            .setAlign(BlocklyBpmn.ALIGN_CENTRE)
            .appendField('"')
            .appendField(new BlocklyBpmn.FieldTextInput(''), 'string_value')
            .appendField('"');
    }
};


BlocklyBpmn.Blocks['number'] = {
    init: function () {
        this.setColour(210);
        this.setOutput(true, ["element"]);

        this.appendDummyInput()
            .setAlign(BlocklyBpmn.ALIGN_CENTRE)
            .appendField('№')
            .appendField(new BlocklyBpmn.FieldTextInput('0', BlocklyBpmn.FieldTextInput.numberValidator), "number_value");
    }
};


BlocklyBpmn.Blocks['dictionary'] = {
    length: 0,
    init: function () {
        this.setColour(120);
        this.setOutput(true, ["element"]);

        this.appendDummyInput('open_bracket')
            .appendField(" { ")
            .appendField(new Blockly_FieldTextbutton('+', function () {
                this.sourceBlock_.appendKeyValuePairInput();
            }));

        this.appendDummyInput('close_bracket')
            .appendField(" } ");

        this.setInputsInline(false);
    },

    appendKeyValuePairInput: function () {
        let result = this.appendKeyValuePairInputWrapper();
        return result[0];

    },
    appendKeyValuePairInputWrapper: function () {

        var lastIndex = this.length++;

        var appended_input = this.appendValueInput('element_' + lastIndex);
        var keyInputField = new BlocklyBpmn.FieldTextInput('key_' + lastIndex);
        appended_input.appendField(new Blockly_FieldTextbutton('–', function () {
            this.sourceBlock_.deleteKeyValuePairInput(appended_input);
        }))
            .appendField(keyInputField, 'key_field_' + lastIndex)
            .appendField(BlocklyBpmn.keyValueArrow())
            .appendSelector(['string', 'number', 'true', 'false', 'dictionary', 'array'], BlocklyBpmn.selectionArrow(), 'null');

        this.moveInputBefore('element_' + lastIndex, 'close_bracket');

        return [appended_input, keyInputField];
    },

    deleteKeyValuePairInput: function (inputToDelete) {

        var inputNameToDelete = inputToDelete.name;

        var substructure = this.getInputTargetBlock(inputNameToDelete);
        if (substructure) {
            substructure.dispose(true, true);
        }
        this.removeInput(inputNameToDelete);

        var inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0]);

        var lastIndex = --this.length;

        for (var i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent element-inputs
            var input = this.getInput('element_' + i);
            input.name = 'element_' + (i - 1);

            var key_field = this.getField('key_field_' + i);
            key_field.name = 'key_field_' + (i - 1);
            // need to also move ddl field
            var ddl_field = this.getField('ddl_element_' + i);
            ddl_field.name = 'ddl_element_' + (i - 1);
        }
    },
    // need to override the default - so we can add the dynamic fields
    getField: function (key) {
        //log("dictionary get field", key);

        for (var b = 0, c; c = this.inputList[b]; b++) {
            //log("input list",c);
            for (var d = 0, e; e = c.fieldRow[d]; d++) {
                //log("field ",e)
                if (e.name == key) {
                    return e;
                }
            }
        }
        // didnt find it, so add one

        var added = this.appendKeyValuePairInputWrapper();
        log("dictionary did not find field so creating", key, added);

        //this.setFieldValue(key, 'key_field_' + this.length);
        return added[1];
        //var elementConnection = targetBlock.getInput('element_' + i).connection;
    }
};

BlocklyBpmn.Blocks['array'] = {
    length: 0,
    init: function () {
        this.setColour(350);
        this.setOutput(true, ["element"]);
        this.appendDummyInput()
            .appendField("enter collection");
        this.appendValueInput("collection")
            .setCheck(null);

        this.appendDummyInput('open_bracket')
            .appendField(" [ ")
            .appendField(new Blockly_FieldTextbutton('+', function () {
                this.sourceBlock_.appendArrayElementInput();
            }));

        this.appendDummyInput('close_bracket')
            .appendField(" ] ");

        this.setInputsInline(false);
    },

    appendArrayElementInputWrapper: function () {

        var lastIndex = this.length++;

        var appended_input = this.appendValueInput('element_' + lastIndex);
        var fieldTextButton = new Blockly_FieldTextbutton('–', function () {
            this.sourceBlock_.deleteArrayElementInput(appended_input);
        });

        appended_input.appendField(fieldTextButton)
            .appendSelector(['string', 'number', 'true', 'false', 'dictionary', 'array'], BlocklyBpmn.selectionArrow(), 'null');

        this.moveInputBefore('element_' + lastIndex, 'close_bracket');

        return [appended_input, appended_input.fieldRow[1]];
    },
    appendArrayElementInput: function () {
        var appended_input = this.appendArrayElementInputWrapper();
        return appended_input[0];
    },

    deleteArrayElementInput: function (inputToDelete) {

        var inputNameToDelete = inputToDelete.name;

        var substructure = this.getInputTargetBlock(inputNameToDelete);
        if (substructure) {
            substructure.dispose(true, true);
        }
        this.removeInput(inputNameToDelete);

        var inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0]);

        var lastIndex = --this.length;

        for (var i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent element-inputs
            var input = this.getInput('element_' + i);

            input.name = 'element_' + (i - 1);
        }
    },
    // need to override the default - so we can add the dynamic fields
    getField: function (key) {
        //log("array get field", key);

        for (var b = 0, c; c = this.inputList[b]; b++) {
            //log("input list",c);
            for (var d = 0, e; e = c.fieldRow[d]; d++) {
                //log("field ",e)
                if (e.name == key) {
                    return e;
                }
            }
        }
        // didnt find it, so add one
        var added = this.appendArrayElementInputWrapper();

        //this.setFieldValue(key, 'key_field_' + this.length);
        return added[1];
        //var elementConnection = targetBlock.getInput('element_' + i).connection;
    },
};

class Blockly_FieldTextbutton extends BlocklyBpmn.Field {
    constructor(buttontext, changeHandler) {
        super('');

        this.buttontext_ = buttontext;
        this.changeHandler_ = changeHandler;
        this.setValue(buttontext);
    }

    clone() {
        return new Blockly_FieldTextbutton(this.buttontext_, this.changeHandler_);
    }

    showEditor_() {
        if (this.changeHandler_) {
            this.changeHandler_();
        }
    }
}
;
//Blockly_FieldTextbutton = new Blockly.Field() ;

//Blockly_FieldTextbutton = function(buttontext, changeHandler) {
//  Blockly_FieldTextbutton.superClass_.constructor.call(this, '');
//
//  this.buttontext_ = buttontext;
//  this.changeHandler_ = changeHandler;
//  this.setText(buttontext);
//};
//goog.inherits(Blockly_FieldTextbutton, Blockly.Field);


//Blockly_FieldTextbutton.prototype.clone = function () {
//    return new Blockly_FieldTextbutton(this.buttontext_, this.changeHandler_);
//};


Blockly_FieldTextbutton.prototype.CURSOR = 'default';


//Blockly_FieldTextbutton.prototype.showEditor_ = function () {
//    if (this.changeHandler_) {
//        this.changeHandler_();
//    }
//};


/***********************/

//Blockly.JavaScript = new Blockly.Generator('JSON');


BlocklyBpmn.JavaScript.toWorkspace = function (json_text, workspace) {
    log('lockly.JSON.toWorkspace', json_text);

    var json_structure = JSON.parse(json_text);

    workspace.clear();

    var startBlock = workspace.newBlock('start');//Blockly.Block.obtain(workspace, 'start');
    startBlock.initSvg();
    startBlock.render();
    BlocklyBpmn.JavaScript.buildAndConnect(json_structure, startBlock.getInput('json').connection);
};


BlocklyBpmn.JavaScript.buildAndConnect = function (json_structure, parentConnection) {
    log('Blockly.JavaScript.buildAndConnect', json_structure, parentConnection);
    if (json_structure === null) {
        return;
    } else {
        var type = typeof (json_structure);
        if (type == 'boolean') {
            type = String(Boolean(json_structure));
        } else if (type == 'object') {
            type = (json_structure instanceof Array) ? 'array' : 'dictionary';
        }

        var targetBlock = parentConnection.sourceBlock_.workspace.newBlock(type);//Blockly.Block.obtain(parentConnection.sourceBlock_.workspace, type);
        targetBlock.initSvg();
        targetBlock.render();

        var childConnection = targetBlock.outputConnection;
        parentConnection.connect(childConnection);

        switch (type) {
            case 'string':
            case 'text':
                targetBlock.setFieldValue(String(json_structure), 'string_value');
                break;
            case 'number':
            case 'math_number':
                targetBlock.setFieldValue(String(json_structure), 'number_value');
                break;
            case 'dictionary':
                var i = 0;
                for (var key in json_structure) {
                    targetBlock.appendKeyValuePairInput();
                    targetBlock.setFieldValue(key, 'key_field_' + i);

                    var elementConnection = targetBlock.getInput('element_' + i).connection;
                    BlocklyBpmn.JavaScript.buildAndConnect(json_structure[key], elementConnection);

                    i++;
                }
                break;
            case 'array':
                for (var i in json_structure) {
                    targetBlock.appendArrayElementInput();

                    var elementConnection = targetBlock.getInput('element_' + i).connection;
                    BlocklyBpmn.JavaScript.buildAndConnect(json_structure[i], elementConnection);
                }
                break;
        }
    }
};

/***********************/


BlocklyBpmn.JavaScript.fromWorkspace = function (workspace, getRawJson) {
    log('Blockly.JavaScript.fromWorkspace ', workspace, getRawJson);

    var json_text = '';

    var top_blocks = workspace.getTopBlocks(false);
    for (var i in top_blocks) {
        var top_block = top_blocks[i];

        if (top_block.type == 'start') {
            var json_structure = this.generalBlockToObj(top_block, getRawJson);

            json_text += JSON.stringify(json_structure, null, 4) + '\n\n';
        }
    }

    return json_text;
};

BpmnBlocklyHelper.getJson = function (workspace, getRawJson) {
    log("BpmnBlocklyHelper.getJson", workspace, getRawJson);
    if (!workspace) {
        workspace = BlocklyBpmn.getMainWorkspace();
    }
    let json = BlocklyBpmn.JavaScript.fromWorkspace(workspace, getRawJson);

    log("BpmnBlocklyHelper.getJson json", json);
    return json;
}

BpmnBlocklyHelper.loadJson = function (json, workspace) {
    log('BpmnBlocklyHelper.loadXML', json, workspace);
    if (!workspace) {
        workspace = BlocklyBpmn.getMainWorkspace();
    }
    if (!workspace) {
        log("could not load workspace");
        return;
    }
    workspace.clear();

    BlocklyBpmn.JavaScript.toWorkspace(json, workspace);

}
BpmnBlocklyHelper.getXML = function (workspace) {
    log("BpmnBlocklyHelper.getXML", workspace);
    if (!workspace) {
        workspace = BlocklyBpmn.getMainWorkspace();
    }
    let xml = BlocklyBpmn.Xml.workspaceToDom(workspace);
    var xml_text = BlocklyBpmn.Xml.domToPrettyText(xml);
    log("BpmnBlocklyHelper.getXML xml", xml_text);
    return xml_text;
}
BpmnBlocklyHelper.inLoadXML = false;// need to know we are loading XML global hack
BpmnBlocklyHelper.loadXML = function (xml_text, workspace) {
    log('BpmnBlocklyHelper.loadXML', xml_text, workspace);
    if (!workspace) {
        workspace = BlocklyBpmn.getMainWorkspace();
    }
    if (!workspace) {
        log("could not load workspace");
        return;
    }
    workspace.clear();
    if (xml_text) {
        var xml = BlocklyBpmn.Xml.textToDom(xml_text);
        // need to disable some things like toggle creating objects if we are loading from XML - otherwise duplicates
        BpmnBlocklyHelper.inLoadXML = true;
        BlocklyBpmn.Xml.domToWorkspace(xml, workspace);
        BpmnBlocklyHelper.inLoadXML = false;

    }

}

class BpmnBlockly_code {
    constructor(code, type) {
        this.code = code;
        this.type = type;
    }
}

class BpmnBlockly_collection {
    constructor(code, arrayVal) {
        this.code = code;
        this.arrayVal = arrayVal;
    }
}

BlocklyBpmn.JavaScript.generalBlockToObj = function (block, getRawJson) {
    log('Blockly.JavaScript.generalBlockToObj', block, getRawJson)
    if (block) {

// dispatcher:
        var func = this[block.type];
        let type = block.type;
        log("generalBlockToObj", type);
        if (func) {
            let result = func.call(this, block, getRawJson);
            switch (type) {
                case "dictionary":
                case "array":
                case "start":
                    return result;
                    break;
                default:
                    // the other operators return [ code, priority]
                    if (Array.isArray(result)) {
                        return new BpmnBlockly_code(result[0], type);
                    }
                    return result;
            }

        } else {
            log("Don't know how to generate JSON code for a '" + block.type + "'");
        }
    } else {
        return null;
    }
};
BpmnBlocklyHelper.arrayVariableStack = [];
BpmnBlocklyHelper.addArrayVariableToStack = function (varName, collectionName) {
    log("BpmnBlocklyHelper.addArrayVariableToStack", varName, collectionName);
    BpmnBlocklyHelper.arrayVariableStack.push({
        varName: varName,
        collectionName: collectionName
    });
    log("arrayVariableStack now ", BpmnBlocklyHelper.arrayVariableStack)
}

BpmnBlocklyHelper.popArrayVariableFromStack = function () {
    log("BpmnBlocklyHelper.popArrayVariableFromStack");
    var result = BpmnBlocklyHelper.arrayVariableStack.pop();
    log("arrayVariableStack now ", BpmnBlocklyHelper.arrayVariableStack)
    return result;
}

/**
 * try to find this attribute name in the stack.
 * ignore the last dot part
 * @param {type} attrName
 * @returns {undefined}
 */
BpmnBlocklyHelper.findVarNameForAttribute = function (attrName) {
    if (attrName instanceof BpmnBlockly_code) {
        return BpmnBlocklyHelper.findVarNameForAttribute.code;
    }
    let components = attrName.split(".");
    if (!components || components.length < 3) {//should be 2 when we fix it
        return attrName;
    }
    let newName = "";
    let sep = "";
    for (let i = 0; i < components.length - 2; i++) {//should be 1 when we fix it
        newName = newName + sep + components[i];
        sep = ".";
    }
    // now have the new name, go through the array
    for (let i = 0; i < BpmnBlocklyHelper.arrayVariableStack.length; i++) {
        let entry = BpmnBlocklyHelper.arrayVariableStack[i];
        let collectionName = entry.collectionName;
        if (collectionName.includes(newName)) {
            log("BpmnBlocklyHelper.findVarNameForAttribute matched", entry, newName);
            let result = entry.varName;
            for (let i = components.length - 1; i < components.length; i++) {//should be 1 when we fix it
                result = result + "." + components[i];

            }
            log("BpmnBlocklyHelper.findVarNameForAttribute found ", newName, result);
            return result;
        }
    }
    log("BpmnBlocklyHelper.findVarNameForAttribute did not find", newName);
    return attrName;
}

BpmnBlocklyHelper.outputJSLine = function (currentLevelPrefix, field, stringBuilder) {
    log("outputJSLine(", currentLevelPrefix, field);
    if (field === null) {
        log("emptyfield");
        return "null";
    }

    if (Array.isArray(field)) {
        log("array field", field);
        let prefix = BpmnBlocklyHelper.getVarName(currentLevelPrefix);
        let line = 'var ' + prefix + "=[];";
        BpmnBlocklyHelper.outputLine(line, stringBuilder)

        for (let i = 0; i < field.length; i++) {
            let nextField = field[i];
            let fieldResult = BpmnBlocklyHelper.outputJSLine(prefix, nextField, stringBuilder);
            line = prefix + ".push(" + fieldResult + ");";
            BpmnBlocklyHelper.outputLine(line, stringBuilder);
        }
        return prefix;
    }

    if (field instanceof BpmnBlockly_code) {
        switch (field.type) {
            case 'string':
            case 'text':
            case 'jason_raw':
            case 'true':
            case 'false':
            case 'number':
                log("Treating code as plain", field.type, field, field.code);
                return field.code;

        }

        return BpmnBlocklyHelper.findVarNameForAttribute(field.code);
    }
    if (field instanceof BpmnBlockly_collection) {
        log("got a BpmnBlockly_collection", field);


        let prefix = BpmnBlocklyHelper.getVarName(currentLevelPrefix);
        let line = 'var ' + prefix + "=[];";
        BpmnBlocklyHelper.outputLine(line, stringBuilder);
        let collectionVarName = BpmnBlocklyHelper.getVarName(prefix);
        BpmnBlocklyHelper.addArrayVariableToStack(collectionVarName, field.code);
        // the camunda doesn't support => so we have to write our own function
        let forEachFuncName = collectionVarName + "_ForEachFunction";

        line = "function " + forEachFuncName + "(" + collectionVarName + ",b,c){";
        BpmnBlocklyHelper.outputLine(line, stringBuilder);
        let arrayField = field.arrayVal;
        for (let i = 0; i < arrayField.length; i++) {
            let nextField = arrayField[i];
            let fieldResult = BpmnBlocklyHelper.outputJSLine(prefix, nextField, stringBuilder);
            line = prefix + ".push(" + fieldResult + ");";
            BpmnBlocklyHelper.outputLine(line, stringBuilder);
        }
        line = "}";


        BpmnBlocklyHelper.outputLine(line, stringBuilder);

        line = field.code + ".forEach(" + forEachFuncName + ");";
        BpmnBlocklyHelper.outputLine(line, stringBuilder);

        BpmnBlocklyHelper.popArrayVariableFromStack();
        return prefix;

    }
    if (typeof field === "object") {
        log("object field");
        let prefix = BpmnBlocklyHelper.getVarName(currentLevelPrefix);
        let line = 'var ' + prefix + "={};";
        BpmnBlocklyHelper.outputLine(line, stringBuilder)

        for (let i in field) {
            let nextField = field[i];
            let nextPrefix = prefix + '["' + i + '"]';
            let fieldResult = BpmnBlocklyHelper.outputJSLine(nextPrefix, nextField, stringBuilder);
            if (fieldResult) {
                if (i === 'payload') {
                    line = nextPrefix + " = /*JSON.stringify*/(" + fieldResult + "); ";// need to do it twice???
                } else {
                    line = nextPrefix + " = " + fieldResult + "; ";
                }

                BpmnBlocklyHelper.outputLine(line, stringBuilder);
            } else {
                if (fieldResult === "") {
                    line = nextPrefix + " = " + "''" + "; ";
                    BpmnBlocklyHelper.outputLine(line, stringBuilder);
                } else {
                    line = nextPrefix + " = " + "null" + "; ";
                    BpmnBlocklyHelper.outputLine(line, stringBuilder);
                }

            }
        }
        return prefix;
    }
    if (!isNaN(field)) {
        log("outputJSLine treating as number ", field)
        return field;
    }


    //should check if number
    log("treating as text");
    return '"' + field + '"';
}
BpmnBlocklyHelper.counter = 0;
BpmnBlocklyHelper.getVarName = function (currentLevelPrefix) {
    return "var" + BpmnBlocklyHelper.counter++;
}
BpmnBlocklyHelper.outputLine = function (line, stringBuilder) {
    stringBuilder.text = stringBuilder.text + "\n" + line;
    log(line);
}


BlocklyBpmn.JavaScript['start'] = function (block, getRawJson) {
    log('Blockly.JavaScript in start', block, getRawJson);
    BpmnBlocklyHelper.counter = 0;
    var json = BlocklyBpmn.JavaScript.generalBlockToObj(block.getInputTargetBlock('json'), getRawJson);
    let stringBuilder = {text: ''};
    BpmnBlocklyHelper.outputJSLine("header", json, stringBuilder);
    let stringifiedJson = JSON.stringify(json);
    log("output is \n", stringifiedJson, "is", stringBuilder.text);
    if (false) {
        var evalout = eval(stringBuilder.text + 'JSON.stringify(var0)');
        var inputstring = JSON.stringify(json);
        log(inputstring);
        log(evalout);
        log(inputstring == evalout);
    }
//    let evalout = eval(stringBuilder.text + 'JSON.stringify(var0)');
//
//
//    let inputstring = JSON.stringify(json);
//            //let outputstring = JSON.stringify(var0);
//            log(inputstring);
//    log(evalout);
//    log(inputstring == evalout);
    if (getRawJson) {
        return stringifiedJson;
    }
    return stringBuilder.text; //JSON.stringify(json);
};
BlocklyBpmn.JavaScript['true'] = function (block) {
    log('in true');
    return [true, BlocklyBpmn.JavaScript.ORDER_NONE];
};
BlocklyBpmn.JavaScript['false'] = function (block) {
    return [false, BlocklyBpmn.JavaScript.ORDER_NONE];
};
BlocklyBpmn.JavaScript['string'] = function (block) {
    var string_value = block.getFieldValue('string_value');
    return ["'" + string_value + "'", BlocklyBpmn.JavaScript.ORDER_NONE];
    //return string_value;
};
BlocklyBpmn.JavaScript['number'] = function (block) {
    var number_value = Number(block.getFieldValue('number_value'));
    return [number_value, BlocklyBpmn.JavaScript.ORDER_NONE];

};
BlocklyBpmn.JavaScript['dictionary'] = function (block, getRawJson) {
    log('Blockly.JavaScript dictionary', block);
    var dictionary = {};
    for (var i = 0; i < block.length; i++) {
        var pair_key = block.getFieldValue('key_field_' + i);
        var pair_value = BlocklyBpmn.JavaScript.generalBlockToObj(block.getInputTargetBlock('element_' + i), getRawJson);
        dictionary[pair_key] = pair_value;
    }

    return dictionary; //JSON.stringify(dictionary);
};
BlocklyBpmn.JavaScript['array'] = function (block, getRawJson) {
    log('Blockly.JavaScript[array] ', block);
    var array = [];
    for (var i = 0; i < block.length; i++) {
        var element_value = BlocklyBpmn.JavaScript.generalBlockToObj(block.getInputTargetBlock('element_' + i), getRawJson);
        array[i] = element_value;
    }
    let result = array;

    var value_collection = BlocklyBpmn.JavaScript.valueToCode(block, 'collection', BlocklyBpmn.JavaScript.ORDER_ATOMIC);
    log("javascript array  value ", value_collection);
    if (value_collection) {
        result = new BpmnBlockly_collection(value_collection, array);
    }

    return result;
};
/************************/

// Disable blocks lying around the workspace unconnected to our main start block.
// (original idea stolen from OpenRoberta and optimized)

var original_onMouseUp_ = BlocklyBpmn.Block.prototype.onMouseUp_;
BlocklyBpmn.Block.prototype.onMouseUp_ = function (e) {
    original_onMouseUp_.call(this, e);
    if (BlocklyBpmn.selected) {
        var rootBlock = BlocklyBpmn.selected.getRootBlock();
        var isDisabled = (rootBlock.type != 'start');
        var descendants = BlocklyBpmn.selected.getDescendants();
        for (var i in descendants) {
            descendants[i].setDisabled(isDisabled);
        }
    }
};
//Blockly.FieldDropdown.prototype.setValue = function(newValue) {      // Allow the label on the closed menu to differ from values of the open menu
//  this.value_ = newValue;
//  // Look up and display the human-readable text.
//  var options = this.getOptions_();
//  for(var x = 0; x < options.length; x++) {
//    // Options are tuples of human-readable text and language-neutral values.
//    if (options[x][1] == newValue) {
//      var shortValue = options[x][2] || options[x][0];
//      this.setText(shortValue);
//      return;
//    }
//  }
//};


BlocklyBpmn.Input.prototype.appendSelector = function (allowedBlocks, presenceLabel, absenceLabel) {

    var presenceLabel = presenceLabel || this.name;
    var absenceLabel = absenceLabel || 'no ' + this.name;
    var ddl_name = 'ddl_' + this.name;
    var dd_list = [
        [absenceLabel, ':REMOVE', absenceLabel]
    ];
    if (allowedBlocks.length == 1) {
        dd_list.push([presenceLabel + ': ', allowedBlocks[0], presenceLabel]);
    } else {
        for (var i = 0; i < allowedBlocks.length; i++) {
            dd_list.push([allowedBlocks[i], allowedBlocks[i], presenceLabel]);
        }
    }

    var this_input = this;
    this//.setCheck(allowedBlocks)  // FIXME: we'll need to re-establish the connection rules somehow!
        .setAlign(this.type == BlocklyBpmn.INPUT_VALUE ? BlocklyBpmn.ALIGN_RIGHT : BlocklyBpmn.ALIGN_LEFT)
        .appendField(new BlocklyBpmn.FieldDropdown(dd_list, function (targetType) {

                return this.sourceBlock_.toggleTargetBlock(this_input, targetType);
            }
        ), ddl_name);
    return this;
};
BlocklyBpmn.Block.prototype.toggleTargetBlock = function (input, targetType) {     // universal version: can create any type of targetBlocks
    // this is giving issues in xml load that duplicates are being created
    if (BpmnBlocklyHelper.inLoadXML) {
        return;
    }
    var targetBlock = input ? this.getInputTargetBlock(input.name) : this.getNextBlock(); // named input or next
    if (targetType == ':REMOVE') {
        if (targetBlock) {
            targetBlock.dispose(true, true); // or targetBlock.unplug(...)
        }
    } else {
        if (targetBlock) {   // Don't remove it, but return the "override" value to make sure the DDL is up to date:
            return targetBlock.type;
        } else {            // add a new kind of block:
            //targetBlock = Blockly.Block.obtain(Blockly.getMainWorkspace(), targetType);
            //https://groups.google.com/g/blockly/c/VKnorn3xXrQ
            targetBlock = BlocklyBpmn.getMainWorkspace().newBlock(targetType);
            targetBlock.initSvg();
            targetBlock.render();
            var parentConnection = input ? this.getInput(input.name).connection : this.nextConnection; // named input or next
            var childConnection = targetBlock.outputConnection || targetBlock.previousConnection; // vertical or horizontal
            parentConnection.connect(childConnection);
        }
    }
};
// A very useful mapping from connection back to input
BlocklyBpmn.Connection.prototype.getInput = function () {
    var inputList = this.sourceBlock_.inputList;
    for (var i in inputList) {
        var connection = inputList[i].connection;
        if (connection == this) {
            return inputList[i];
        }
    }
};
// If there is a ddl linked with the input, update its label to the type of the block plugged in:
BlocklyBpmn.Input.prototype.updateLinkedDDL = function () {

    var ddl_name = this.name;
    log('Blockly.Input.prototype.updateLinkedDDL need to fix ', ddl_name, this);
//    let sourceBlock = this.sourceBlock_;
//    let inputList = sourceBlock.inputList;
//    for (let i = 0; i < inputList.length; i++) {
//        let ddl_field = inputList[i];
//        let fieldName = ddl_field.name;
//        if (fieldName === ddl_name) {
//            log("updateLinkedDDL found ", ddl_name);
//            var targetBlock = this.connection.targetBlock();
//            var type = targetBlock ? targetBlock.type : ':REMOVE';
//            ddl_field.type= type;
//        }
//    }
//    var ddl_field = this.sourceBlock_.getField_(ddl_name);
//    if (ddl_field) {
//        var targetBlock = this.connection.targetBlock();
//        var type = targetBlock ? targetBlock.type : ':REMOVE';
//        ddl_field.setValue(type);
//    }
};
// Update the DDL on connect() :
var original_connect = BlocklyBpmn.Connection.prototype.connect;
BlocklyBpmn.Connection.prototype.connect = function (otherConnection) {

    original_connect.call(this, otherConnection);
    var parentConnection = this.isSuperior() ? this : otherConnection; // since connect() is symmetrical we never know which way it is called

    //parentConnection.getInput().updateLinkedDDL();
};
// Update the DDL on disconnect() :
var original_disconnect = BlocklyBpmn.Connection.prototype.disconnect;
BlocklyBpmn.Connection.prototype.disconnect = function () {

    var parentConnection = this.isSuperior() ? this : this.targetConnection; // since disconnect() is symmetrical we never know which way it is called

    original_disconnect.call(this);
    //parentConnection.getInput().updateLinkedDDL();
};

// got these 2 from the blockly code and overridden them due to errors in nulls
BlocklyBpmn.InsertionMarkerManager.prototype.createMarkerBlock_ = function (a) {
    //log("xxxx Blockly.InsertionMarkerManager.prototype.createMarkerBlock_")
    var b = a.type;
    BlocklyBpmn.Events.disable();
    try {
        var c = this.workspace_.newBlock(b);
        c.setInsertionMarker(!0);
        if (a.mutationToDom) {
            var d = a.mutationToDom();
            d && c.domToMutation(d)
        }
        for (b = 0; b < a.inputList.length; b++) {
            var e = a.inputList[b];
            if (e.name != BlocklyBpmn.Block.COLLAPSED_INPUT_NAME) {
                var f = c.inputList[b];
                for (d = 0; d < e.fieldRow.length; d++)
                    //AS 2020-10-16
                    if (f && f.fieldRow && f.fieldRow[d]) {
                        f.fieldRow[d].setValue(e.fieldRow[d].getValue())
                    }
            }
        }
        c.setCollapsed(a.isCollapsed());
        c.setInputsInline(a.getInputsInline());
        c.initSvg();
        c.getSvgRoot().setAttribute("visibility", "hidden")
    } finally {
        BlocklyBpmn.Events.enable()
    }
    return c
};

// Blockly.Gesture.prototype.handleMove = function (a) {
//     //log("xxxxx Blockly.Gesture.prototype.handleMove ")
//     this.updateFromEvent_(a);
//     // AS 2020-10-16 block dragger was null
//     this.isDraggingWorkspace_ ? this.workspaceDragger_.drag(this.currentDragDeltaXY_) :
//         this.isDraggingBlock_ ? this.blockDragger_ && this.blockDragger_.dragBlock(this.mostRecentEvent_, this.currentDragDeltaXY_) :
//             this.isDraggingBubble_ && this.bubbleDragger_.dragBubble(this.mostRecentEvent_, this.currentDragDeltaXY_);
//     a.preventDefault();
//     a.stopPropagation()
// };


